'use client'

import { SectionHeader } from '@/components/shared/section-header'
import { BlokProps } from '@/lib/types'
import { ComparisonSliderStoryblok } from '@/lib/types/component-types-sb'
import { storyblokEditable } from '@storyblok/react/rsc'
import dynamic from 'next/dynamic'

const ReactCompareSlider = dynamic(() =>
  import('react-compare-slider').then((m) => m.ReactCompareSlider),
)
const ReactCompareSliderImage = dynamic(() =>
  import('react-compare-slider').then((m) => m.ReactCompareSliderImage),
)
const ReactCompareSliderHandle = dynamic(() =>
  import('react-compare-slider').then((m) => m.ReactCompareSliderHandle),
)

export function ComparisonSlider({ blok }: BlokProps<ComparisonSliderStoryblok>) {
  return (
    <section
      {...storyblokEditable(blok)}
      className="border-border border-y py-32"
    >
      <div className="page-container space-y-14">
        <SectionHeader
          title={blok.title}
          icon={blok.descriptorIcon}
          preTitle={blok.descriptorTitle}
          content={blok.content}
        />
        {blok.leftImage?.filename && blok.rightImage?.filename && (
          <ReactCompareSlider
            className="overflow-hidden rounded-lg"
            handle={
              <ReactCompareSliderHandle
                style={{
                  color: 'var(--color-brand)',
                }}
                buttonStyle={{
                  borderColor: 'var(--color-brand)',
                }}
              />
            }
            itemOne={
              <ReactCompareSliderImage
                src={blok.leftImage?.filename}
                alt={blok.leftImage?.alt ?? ''}
              />
            }
            itemTwo={
              <ReactCompareSliderImage
                src={blok.rightImage?.filename}
                alt={blok.rightImage?.alt ?? ''}
              />
            }
          />
        )}
      </div>
    </section>
  )
}
